import RemoteCollection from "#root/utility/remote-collection";
import * as z from "zod";

export const CorrespondenceAttachmentSchema = z.object({
  filename: z.string(),
  content: z.string(),
  contentType: z.string(),
  encoding: z.string(),
});

export const CorrespondenceListItemSchema = z.object({
  id: z.number(),
  date: z.string(),
  accountName: z.string().nullish(),
  subject: z.string().nullish(),
});
export const CorrespondenceDetailItemSchema = CorrespondenceListItemSchema.extend({
  status: z.string(),
  accountId: z.number().nullish(),
  from: z.string().nullish(),
  to: z.string().nullish(),
  cc: z.string().nullish(),
  bcc: z.string().nullish(),
  subject: z.string().nullish(),
  reference: z.string().nullish(),
  bodyFormat: z.string().nullish(),
  body: z.string().nullish(),
  attachments: z
    .any()
    .nullish()
    .transform(item => {
      if (item && Array.isArray(item)) {
        const items: z.infer<typeof CorrespondenceAttachmentSchema>[] = [];
        for (const attachment of item) {
          const parsed = CorrespondenceAttachmentSchema.safeParse(attachment);
          if (parsed.success) {
            items.push(parsed.data);
          }
        }
        if (items.length > 0) return items;
      }
      return undefined;
    }),
}).loose();

export type CorrespondenceListItem = z.output<typeof CorrespondenceListItemSchema>;
export type CorrespondenceDetailItem = z.output<typeof CorrespondenceDetailItemSchema>;

export const correspondenceCollection = new RemoteCollection("/api/correspondence", CorrespondenceListItemSchema, CorrespondenceDetailItemSchema);
